import { Fragment, useContext } from 'react';
import { ViContext } from '../../context/ViContext';

function OriginContent(props) {
	const { selectSgg, selectEmd } = useContext(ViContext);

	return (
		<Fragment>
			<h2 className="mapSelectTit">· 시군구로 보는 지역활력지수</h2>
			<div className="regionChecked">
				<label>
					<input
						type="radio"
						name="selectSgg"
						value="region"
						checked={selectSgg === 'region'}
						onChange={props.handelSelectRadio}
					/>
					지역활력지수
				</label>
				<label>
					<input
						type="radio"
						name="selectSgg"
						value="pop"
						checked={selectSgg === 'pop'}
						onChange={props.handelSelectRadio}
					/>
					인구활력도
				</label>
				<label>
					<input
						type="radio"
						name="selectSgg"
						value="consume"
						checked={selectSgg === 'consume'}
						onChange={props.handelSelectRadio}
					/>
					소비활력도
				</label>
				<label>
					<input
						type="radio"
						name="selectSgg"
						value="prod"
						checked={selectSgg === 'prod'}
						onChange={props.handelSelectRadio}
					/>
					생산활력도
				</label>
			</div>

			<div className="dotLine"></div>

			<h2 className="mapSelectTit">· 읍면동으로 보는 지역활력지수</h2>
			<div className="regionChecked">
				<label>
					<input
						type="radio"
						name="selectEmd"
						value="region"
						checked={selectEmd === 'region'}
						onChange={props.handelSelectRadio}
					/>
					지역활력지수
				</label>
				<label>
					<input
						type="radio"
						name="selectEmd"
						value="pop"
						checked={selectEmd === 'pop'}
						onChange={props.handelSelectRadio}
					/>
					인구활력도
				</label>
				<label>
					<input
						type="radio"
						name="selectEmd"
						value="consume"
						checked={selectEmd === 'consume'}
						onChange={props.handelSelectRadio}
					/>
					소비활력도
				</label>
				<label>
					<input
						type="radio"
						name="selectEmd"
						value="prod"
						checked={selectEmd === 'prod'}
						onChange={props.handelSelectRadio}
					/>
					생산활력도
				</label>
			</div>
		</Fragment>
	);
}

export default OriginContent;
